import React, { useContext } from 'react';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { useIntl } from 'react-intl';
import { buildIdCloudLoginUrl, logoutActiveAuth } from '../../auth/session';

const AdminLogout = () => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const {
    setAuthToken,
    setCurrentUser,
    authSource,
    setAuthSource
  } = useContext(RootContext);

  const getLogoutHref = () => {
    const location = window.location.pathname
    let path = location !== '/' ? location : ''
    path = path?.split('?')[0]
    return buildIdCloudLoginUrl(path)
  }

  const logout = async () => {
    setAuthToken(null);
    setCurrentUser(null);
    setAuthSource(null);
    await logoutActiveAuth({ authSource });
    window.location.href = getLogoutHref()
  }

  return (
    <div>
      <button className="btn-clear" onClick={logout}>{t('ui.logout')}</button>
    </div>
  )
}

export default AdminLogout;
